import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { NodeViewWrapper } from '@tiptap/vue-3';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { computed, provide } from 'vue';
import SpecificMedia from './specificMedia/SpecificMedia.vue';
import { Editor } from '@tiptap/core';
import { InlineMediaType } from '@superthread-com/extension-inline-media/src/index';

/**
 * The correct type definition would be:
 * const props = defineProps<typeof nodeViewProps>();
 *
 * However, that is not supported in Vue 2, so the type must be
 * specified like this.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'GenericMedia',
  props: {
    node: {},
    deleteNode: { type: Function },
    editor: {},
    updateAttributes: {}
  },
  setup(__props: any) {

const props = __props;

provide(
  'node',
  computed(() => props.node)
);
provide('deleteNode', props.deleteNode);
provide('editor', props.editor);
provide('updateAttributes', props.updateAttributes);

function mt(mediaType: InlineMediaType) {
  return props.node.attrs.mediaType === mediaType;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NodeViewWrapper), {
    class: _normalizeClass(["generic-file-wrapper", {
      '!w-full': mt(_unref(InlineMediaType).Video),
      'w-[260px]': props?.node?.attrs?.mediaType === _unref(InlineMediaType).File,
    }]),
    "data-block-id": props?.node?.attrs?.['block-id']
  }, {
    default: _withCtx(() => [
      _createVNode(SpecificMedia, {
        type: props.node.attrs.mediaType,
        editor: props.editor
      }, null, 8, ["type", "editor"])
    ]),
    _: 1
  }, 8, ["class", "data-block-id"]))
}
}

})